
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"9","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.469 6.57h-14l1.258 1.508-.508.43-3.82-3.82v-.5l3.82-3.82.508.429-1.25 1.492h13.992v1.04H2.679l-.898 1.108.883 1.094H17.47v1.04z","fill":"currentColor"}})])
          )
        }
      }
    